import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import { parseConfig } from 'api/getChannels';

const mutation = gql`
mutation UpdateChannel($id: ID!, $model: ChannelInput!) {
  updateChannel(id: $id, channel: $model) {
    id
    name
    type
    priority
    identifier
    group {
      id
      name
      description
    }
    teams {
      id
      name
    }
    allTeamsOn
    requestTypePriorities {
      id
      weight
    }
    config
  }
}`;

function updateChannel(id, fields, model) {
  const config = {};
  fields.forEach((item) => {
    config[item.name] = item.value;
  });
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
      model: {
        ...model,
        config: JSON.stringify(config),
      },
    },
  })
    .then((res) => res.data.updateChannel)
    .then((channel) => ({
      ...channel,
      fields: parseConfig(channel.config),
    }));
}

export default updateChannel;
